import t from 'ember-intl/helpers/t';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface OnboardingSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const OnboardingComponent = <template>
  <div class='onboarding' ...attributes>
    <div class='onboarding__container'>
      <h1 class='bv-app-logo'>
        <a href='http://www.bevolta.com' title='{{t "bevolta"}}'>
          {{t 'bevolta'}}
        </a>
      </h1>
      <div class='onboarding__content'>
        {{yield}}
      </div>
    </div>
  </div>
</template> satisfies TemplateOnlyComponent<OnboardingSignature>;

export default OnboardingComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    Onboarding: typeof OnboardingComponent;
    onboarding: typeof OnboardingComponent;
  }
}
